<template>
    <div v-if="data" class="mr-3 uncomp-jobs">
        <v-tooltip text="Nuwall Stock" location="bottom">
            <template v-slot:activator="{ props }">
                <v-badge @click="show = true" :content="data.stock.length">
                    <v-icon icon="mdi-alpha-n-box" v-bind="props" class="text-yellow-lighten-3"></v-icon>
                </v-badge>
            </template>
        </v-tooltip>
        <v-dialog v-model="show"
                  persistent
                  fullscreen
                  transition="dialog-bottom-transition"
                  :scrim="false">
            <v-card>
                <v-toolbar dark
                           color="primary">
                    <v-toolbar-title>Nu-Wall Stock</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon
                           dark
                           @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="d-flex">
                    <v-row>
                        <v-col cols="6" class="border-e-sm">
                            <h3>Recent Stock Removals</h3>
                            <p>Below is all recent Nu-Wall picked stock transactions.</p>
                            <div class="h-100 overflow-y-auto">
                                <v-table>
                                    <tbody>
                                        <tr>
                                            <th>Date</th>
                                            <th>Item</th>
                                            <th>Quantity</th>
                                            <th>Job</th>
                                        </tr>
                                        <tr v-for="item in data.recent" :key="item.id">
                                            <td>{{ $dayjs(item.dateCreated).format('DD-MM-YYYY') }}</td>
                                            <td>{{ item.description }}</td>
                                            <td>{{ item.quantity }}</td>
                                            <td><job-link :job="item"></job-link></td>
                                        </tr>
                                    </tbody>
                                </v-table>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <h3>Outstanding Stock → Strip</h3>
                            <p>Below is all outstanding Nu-Wall stock to be stripped. Convert these items to a job to process before adding back to stock.</p>
                            <div class="d-flex justify-space-between border-t-sm border-b-sm my-2 py-2">
                                <h3>{{ totalItemsToStrip }} <small class="text-muted">TOTAL ITEMS TO STRIP</small></h3>
                                <v-btn prepend-icon="mdi-archive-sync-outline" 
                                       :disabled="totalItemsToStrip  == 0"
                                       :loading="saving"
                                       @click="convertToStrip">CONVERT ITEMS TO STRIP JOB</v-btn>
                            </div>
                            <v-table>
                                <tbody>
                                    <tr>
                                        <th>Date</th>
                                        <th>Item</th>
                                        <th>Quantity</th>
                                        <th>Job</th>
                                    </tr>
                                    <tr v-for="item in data.stock" :key="item.id">
                                        <td>{{ $dayjs(item.dateCreated).format('DD-MM-YYYY') }}</td>
                                        <td>{{ item.description }}</td>
                                        <td>{{ item.quantity }}</td>
                                        <td><job-link :job="item"></job-link></td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .uncomp-jobs {
        cursor:pointer;
    }
</style>
<script>
    import { numberWithCommas } from "../mixins/numberMixins";
    import { mapActions } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
            show: false,
            data: null,
            refreshInterval: null
        };
    }
    export default {
        name: "NuwallStock",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadData();
            this.refreshInterval = setInterval(() => {
                this.loadData();
            }, 600000);
        },
        beforeUnmount: function () {
            // Clean up the interval when component is destroyed
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }
        },
        props: {
            props: Object,
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            numberWithCommas,
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            loadData() {
                this.loading = true;
                this.$api.get('dashboard/nuwallstock')
                    .then(res => {
                        this.data = res.data;
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("Whoops. We ran into an error.");
                    });
            },
            convertToStrip() {
                this.$confirm(
                    {
                        message: 'This will convert all outstanding strip items to a stripping job. Are you sure?',
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                this.saving = true;
                                this.$api.post('dashboard/convertnuwallstripstock')
                                    .then(res => {
                                        this.saving =  false;
                                        this.loadData();
                                        this.show = false;
                                        this.$router.push(`/jobs/${res.data.id}`);
                                    }).catch(error => {
                                        this.saving = false;
                                        this.showErrorSnack("Whoops. We ran into an error.");
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
            totalItemsToStrip() {
                return this.data.stock.reduce((acc, obj) => acc + obj.quantity, 0);
            }
        }
    };
</script>